<template>
  <aside class="project-one-right-rail" qaid="project-one-right-rail">
    <project-one-right-rail-header
      :base-properties="baseProperties"
      :group-id="groupId"
      :is-back-button-enabled="true"
      @on-backpress="returnToPreviousRailView"
    />

    <section class="project-one-right-rail__body" qaid="project-one-right-rail-body">
      <form-group
        type="radio"
        name="choices"
        :multi-items="sizeGroupOptions"
        :value="selectedValue"
        @change="selectChoice"
      />
    </section>

    <project-one-right-rail-footer
      :base-properties="baseProperties"
      :button-action="confirmSelection"
      button-icon="check"
      :button-icon-left="true"
      :button-primary="true"
      :button-text="bp('done')"
    />
  </aside>
</template>

<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex';
import ProjectOneRightRailFooter from '@/projectOne/components/rightRail/components/ProjectOneRightRailFooter';
import ProjectOneRightRailHeader from '@/projectOne/components/rightRail/components/ProjectOneRightRailHeader';
import FormGroup from '@/components/FormGroup';

export default {
  components: {ProjectOneRightRailFooter, ProjectOneRightRailHeader, FormGroup},
  computed: {
    selectedValue() {
      const selection = this.selections.find((selection) => selection.groupId === this.contentData?.id);
      return selection.choiceId;
    },
    contentData() {
      if (this.activeRailData?.content?.groupId && Array.isArray(this.moduleGroups)) {
        return this.moduleGroups.find((group) => group.id === this.activeRailData.content.groupId);
      }

      return null;
    },

    groupId() {
      return this.contentData?.id;
    },

    topTierPackageId() {
      return this.contentData?.topTierPackageId;
    },

    sizeGroupOptions() {
      // make a deep copy of 'this.contentData', we dont want to change 'this.contentData'
      const choicesList = [...this.contentData?.choices];
      let result = choicesList.map((currentObject) => {
        return {
          value: currentObject.id,
          displayName: currentObject.description,
          checked: this.isSelected(currentObject.id),
        };
      });
      return result;
    },

    ...mapGetters('projectOne', ['activeRailData']),
    ...mapState('projectOne', ['currentRoute', 'moduleGroups', 'railDataStack', 'selections']),
  },

  methods: {
    confirmSelection() {
      this.$notify({
        type: 'success',
        message: this.bp('added'),
      });

      this.returnToInitialRailView();
    },

    isSelected(id) {
      return (
        id ===
        this.selections?.find((selection) => selection.groupId === this.activeRailData?.content?.groupId)?.choiceId
      );
    },

    returnToInitialRailView() {
      while (this.railDataStack?.length > 1) {
        this.popRailDataStack();
      }
    },

    returnToPreviousRailView() {
      if (this.railDataStack?.length > 1) {
        this.popRailDataStack();
      } else {
        this.$emit('on-backpress');
      }
    },

    selectChoice(event) {
      this.updateSelection({
        buildId: this.$route.params.buildId,
        module: this.currentRoute,
        selections: [{groupId: this.groupId, choiceId: event.target.value, topTierPackageId: this.topTierPackageId}],
      });
    },

    ...mapActions('projectOne', ['updateSelection']),
    ...mapMutations('projectOne', ['popRailDataStack', 'pushToRailDataStack']),
  },
};
</script>
